import {lighten, styled} from "@mui/material/styles";

export const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: lighten(theme?.palette?.text?.secondary, .5),
  backgroundColor: lighten(theme?.palette?.grey?.[300], .6),
  fontWeight: 'bold',
}));